export const version = "v1.2.0"
export const wxappId = "wx5ca2a4f3dcbdcedb"
